import Header from '../../../__Layout/Header';
import React ,{useState} from "react";
import Loader from '../../../utils/Loader';
import { useGetParticipantsQuery,useGetStudentCourseTopicQuery,useGetStudentCourseTopicDetailQuery} from "../../../Services/api";
import { pageUrl, pageSize } from "../../../utils/constants/constants";
import "../../../assets/niceapms/assets/css/style.css"
import {Link, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import {  useSelector,useDispatch } from 'react-redux';

export default function StudentCourseTopic() {   
    const { id,lpid } = useParams();
   
    const paramC= 'course_id='+id;
    const lpidParam= 'lpid='+lpid;
    
    const param = id + '/' + lpid;
    const {
        data: CourseTopic,
        isLoading: isGetLoading,
    } = useGetStudentCourseTopicQuery({ pageUrl, params: paramC });
    const {
        data: CourseTopicDetail,
        isLoading: isGetLoadingDetail,
    } = useGetStudentCourseTopicDetailQuery({ pageUrl, params: lpidParam });
    
    const {userDetail } = useSelector((state) => state.auth)
    const authType = localStorage.getItem('authType');

 const [page, setPage] = useState(0);
 
 const {
        data: getParticipants,
    } = useGetParticipantsQuery({ pageUrl, params: { param, page, pageSize } });
    if(isGetLoading || isGetLoadingDetail) return  <Loader></Loader>
   
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">My Courses/Training</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training</button>
                        </li>
                        <li>
                            <Link to={`/student-course`} className='btn btn-dark pull-right'>Back </Link>
                        </li> 
                       
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                   <div className='col-md-6 col-sm-12 col-xs-12 '>
                                        <table className="table table-bordered">
                                            <thead className='bg-warning text-dark'>
                                                <tr>
                                                    <th className='text-capitalize'>Element No</th>
                                                    <th className='text-capitalize'>Element Name</th>  
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                CourseTopic?.data?.map((item,index) => {
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{item.element_name.replace('Element','')}</th>
                                                        <th><h5><Link className='text-warning' to={`/student-course-topic/${item.course_id}/${item.lpid}`}>{item.element_tag}</Link></h5></th>                                                                    
                                                    </tr>                                             
                                                    )  
                                                })  
                                            } 
                                            </tbody>
                                        </table> 
                                        <h2> Mock Exam</h2>
                                        <table className="table table-bordered">
                                            <thead className='bg-warning text-dark'>
                                                <tr>
                                                    <th className='text-capitalize'>Questions No</th>
                                                    <th className='text-capitalize'>Questions Name</th>  
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                            {
                                                CourseTopic?.LongQuestionSenario?.map((item,index) => {
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{index+1}</th>
                                                        <th><h5><Link className='text-warning'
                                                         to={`/long-question-detail/${item.course_id}/${item.lqs_id}`}
                                                         >View</Link></h5></th>                                                                    
                                                    </tr>                                             
                                                    )  
                                                })  
                                            } 
                                            </tbody>
                                        </table>
                                   </div><div className='col-1'></div>
                                   <div className='col-md-5 col-sm-12 col-xs-12 '>
                                        {/* navbar */}
                                        { (authType=='2' && userDetail?.user[0]?.student_id=='41' && CourseTopicDetail?.data?.length > 0 ) && 
                                            <ul className="d-flex list-unstyled gap-3">
                                                <li>    <Link className="nav-link text-decoration-underline" to={`/course-participants/${id}/${lpid}`}><strong>Participants</strong> </Link></li>
                                                <li>    <Link className="nav-link text-decoration-underline" to="#"><strong>Grade</strong> </Link></li>
                                                <li>    <Link className="nav-link text-decoration-underline" to="#"><strong>Competencies</strong></Link></li>
                                            </ul>
                                        }
                                        
                                        {/* end navbar */}
                                        <table className="table table-bordered">
                                            
                                            {
                                                CourseTopicDetail?.data?.map((item,index) => {
                                                return (
                                                        <tbody  key={index}>
                                                            <tr>
                                                                <td className='bg-warning text-dark'><h5>{item.element_name}</h5></td>
                                                            </tr> 
                                                            <tr>
                                                                <td><h5>{parse(item.introduction)}</h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td> 
                                                                  <h5><Link className='text-primary' to={`/student-course-outcome/${item.lpid}/${item.course_id}`}>Learner notes</Link></h5>
                                                                </td>
                                                            </tr>
                                                            {
                                                                item.relevant_question == '1' ?
                                                                <tr>
                                                                    <td>
                                                                    <h5><Link className='text-primary' to={`/paid-course-relevent-question/${item.lpid}/${item.course_id}`}>Relevant Question</Link></h5>
                                                                    </td>
                                                                </tr>
                                                                :""
                                                            }
                                                            
                                                            {
                                                                item.course_id == '3' ?
                                                                    <tr>
                                                                        <td>
                                                                        <h5><Link className='text-primary' to="https://www.nebosh.org.uk/qualifications/international-general-certificate/#resources" target="_blank">Relevant Sample Paper</Link></h5>
                                                                        </td>
                                                                    </tr>
                                                                :""
                                                            }
                                                            
                                                            
                                                        </tbody>                                        
                                                    )  
                                                })  
                                            } 
                                           
                                        </table> 
                                   </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
